export default __webpack_public_path__ + "static/media/bubble_nova_m1.4caf5d31.png";